import ReactDOM from 'react-dom'
import ReactTooltip from 'react-tooltip'
import {
  ContactSellerModalConsumer,
  ContactSellerModalProvider,
} from './context/ContactSellerContext'

function BidButton() {
  return (
    <a
      className="btn btn-primary w-100 ga-event"
      data-ga-event={JSON.stringify({
        category: 'Car Page',
        action: 'Click Bid',
      })}
      href={App.State.bidUrl}
      target="_blank"
      rel="nofollow noreferrer"
    >
      <i className="far fa-gavel me-1" />
      <span>{I18n.t('bid')}</span>
    </a>
  )
}

function ContactButton({ openContactModal }) {
  const errorMessage = () => {
    if (App.State.carOwner) {
      return I18n.t('contact.cannot_message_yourself')
    } else if (!App.State.isConfirmed && App.State.userSignedIn) {
      return I18n.t('contact.confirm_email')
    }
  }

  return (
    <span data-tip={errorMessage()} data-tip-disable={false}>
      <button
        type="button"
        className="btn btn-primary w-100 ga-event rounded-8"
        disabled={App.State.carOwner}
        data-ga-event={JSON.stringify({
          category: 'Car Page',
          action: 'Click Contact Seller',
        })}
        onClick={() => openContactModal()}
      >
        <i className="far fa-envelope me-1" />
        <span>{I18n.t('contact_seller')}</span>
      </button>
      {(App.State.carOwner && <ReactTooltip />) ||
        (!App.State.isConfirmed && <ReactTooltip />)}
    </span>
  )
}

function ContactSellerButton() {
  return (
    <ContactSellerModalProvider>
      <ContactSellerModalConsumer>
        {({ openContactModal }) =>
          App.State.biddingAllowed ? (
            <BidButton />
          ) : (
            <ContactButton openContactModal={openContactModal} />
          )
        }
      </ContactSellerModalConsumer>
    </ContactSellerModalProvider>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ContactSellerButton />,
    document.getElementById('contact-seller-button')
  )
})
